import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import { toast } from "react-toastify";
import { Data } from "../../../../components/Formatters/DateTime";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import constants from "../../../Constants";

const columns = [
  {
    name: "Nº Itinerância",
    selector: "sqItinerancia",
    minWidth: "70px",
    center: true,
    sortable: true,
  },
  {
    name: "Operação",
    selector: "sqCodigoOperacional",
    minWidth: "250px",
    center: true,
    sortable: true,
    cell: (row) => (
      <span>
        {row.sqCodigoOperacional} - {row.dsCodigoOperacional}
      </span>
    ),
  },
  {
    name: "Período de Fiscalização",
    selector: "dtInicio",
    minWidth: "250px",
    center: true,
    sortable: true,
    cell: (row) => (
      <span>
        <Data value={row.dtInicio} /> à <Data value={row.dtFim} />
      </span>
    ),
  },
  {
    name: "Situação",
    selector: "stAcao",
    minWidth: "80px",
    center: true,
    sortable: true,
  },
];

const useItinerancia = (sqPessoa) => {
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    const value = {
      SqPessoa: sqPessoa,
      pageSize,
      pageNumber,
    };

    request(apiRoutes.fiscalizacao.ordemservico.listaItinerancia, value);
  }, [pageNumber, pageSize, request, sqPessoa]);

  useEffect(() => {
    if (!data && !errors) return;

    if (data?.result.length > 0) {
      setRows(data?.result || []);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  const listaItinerancia = (
    <div style={{ width: "100%" }}>
      <Row>
        <Col>
          <h5>Itinerância</h5>
          <DataTable
            noHeader
            keyField="SqItinerancia"
            columns={columns}
            data={rows}
            progressPending={isLoading}
            noDataComponent="Não existem registros."
            progressComponent={<TextSpinner />}
            defaultSortFieldId={1}
            sortIcon={<BsArrowDown />}
            pagination
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={constants.paginationComponentOptions}
            sortable
            pointerOnHover
            paginationPerPage={pageSize}
          />
        </Col>
      </Row>
    </div>
  );

  return { listaItinerancia };
};

export default useItinerancia;
